export enum ProjectSignalingStatusEnum {
  InProject = 'IN_PROJECT',
  InTask = 'IN_TASK',
  InCatalog = 'IN_CATALOG'
}